/* lm9.js: a LED-maszk oldal v9 blokkjai (2026-10-27, Marci: „az artifactben lévő design menjen rá”).
   Forrás: theme-src/lm9-2026-10/src/lm9.js, a build.py nyelvenként a T szótárt tölti (window.LM9T).
   A szövegek egyszeres idézőjelben állnak, a build ezeket cseréli T[...]-re. A kosár az élő buybox (ledmask-buy2) formja. */
(() => {
  const T = window.LM9T || {};
  const root = document.querySelector('.lm9[data-part="main"]');
  if (!root || root.dataset.on) return; root.dataset.on = '1';
  const $ = id => document.getElementById('lm9-' + id);
  const IMG = n => root.dataset.imgb + n;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const D = root.dataset;

  /* ---------- VÁLASZTÁS: az élő buybox radio-kártyáit vezérli (maszk / maszk + alap rutin) ---------- */
  const buy = document.querySelector('.lm2-buy');
  const pickIn = h => buy && buy.querySelector('.lm2-pick__c[data-handle="' + h + '"] input');
  const hasBundle = !!pickIn(D.hb);
  const OPT = {
    mask:  {price:D.pm, old:'', t:T["k2b67039ece"], img:D.im},
    bundle:{price:D.pb, old:D.pbo, t:D.bfName || T["k6ecaf67989"], img:D.ib}
  };
  /* BF (2026-11-01 23:00): a rutin-blokk fejlécébe a „teljes rutin ingyen” jelzés, a gombra az ingyen szó (ledmask-v9.liquid data-bf*) */
  if (D.bf) {
    const sub = document.querySelector('#lm9-rutin .rt-hd .sub');
    if (sub && !sub.nextElementSibling?.classList.contains('bfrt')) sub.insertAdjacentHTML('afterend', '<p class="bfrt"></p>');
    const bfp = document.querySelector('#lm9-rutin .bfrt'); if (bfp) bfp.textContent = D.bf;
    const ob = document.getElementById('lm9-o-base'); if (ob && D.bfBtn) ob.textContent = D.bfBtn;
  }
  let opt = 'mask';
  function setOpt(o, fromBuy){
    if (o === 'bundle' && !hasBundle) o = 'mask';
    opt = o; const d = OPT[o];
    document.querySelectorAll('.lm9 .opt').forEach(b => b.setAttribute('aria-pressed', b.dataset.opt === o));
    const st = $('st-t'), sp = $('st-p');
    if (st) st.textContent = d.t;
    if (sp) sp.textContent = d.price + ' · ' + T["k0e3d001593"];
    if (!fromBuy) { const inp = pickIn(o === 'bundle' ? D.hb : D.hm); if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', {bubbles:true})); } }
    if (typeof window.lm9SetBase === 'function') window.lm9SetBase(o === 'bundle', true);
  }
  if (buy) buy.addEventListener('change', e => { const c = e.target.closest && e.target.closest('.lm2-pick__c'); if (c) setOpt(c.dataset.handle === D.hb ? 'bundle' : 'mask', true); });
  document.querySelectorAll('.lm9 .opt').forEach(b => b.addEventListener('click', () => setOpt(b.dataset.opt)));
  function addToCart(){
    const f = buy && buy.querySelector('form.ucpc__form'), btn = f && f.querySelector('.lm2-btn');
    if (f && btn && !btn.disabled) { if (f.requestSubmit) f.requestSubmit(btn); else btn.click(); }
    else if (buy) buy.scrollIntoView({block:'start', behavior: reduce ? 'auto' : 'smooth'});
  }
  document.addEventListener('click', e => { if (e.target.closest && e.target.closest('.lm9 [data-add]')) addToCart(); });
  if (!hasBundle) document.querySelectorAll('.lm9 [data-needs-bundle]').forEach(el => el.hidden = true);

  /* ---------- SPEKTRUM ---------- */
  // A gyári ábra skálája (kimérve): 414 nm -> 177 px, 634 nm -> 558 px, kép 1181 px széles.
  const X = nm => (177 + (nm - 414) * (381 / 220)) / 1181 * 100;
  const BANDS = {
    kek:  {from:414, to:445, lab:T["k7c6d92513e"], c:'#4657FF'},
    voros:{from:630, to:670, lab:T["k918738b4e4"], c:'#FF3B22'}
  };
  const PEAK = {kek:[414,'#4657FF'], zold:[515,'#1DB954'], voros:[634,'#FF3B22'], nir:[853,'#8E1B10']};
  // fx: [mit vizsgáltak, forrás]. Hatás-ígéret NINCS: csak a hullámhossz és a más készülékkel készült vizsgálat.
  // fx: [mire vizsgálták, mi lett az eredmény, forrás és korlát] (claim-verify 3. kör, 10-27). A „Mire való” a nyomtatott útmutató kozmetikai leírása (a claim-plafon).
  const S_RED = [T["k617cc52223"], T["k593ea7a59e"], T["kfbcdf82b79"]];
  const S_RED_META = [T["k05c5fb0e91"], T["k2620c7d622"], T["k98b310abe5"]];
  const S_BLUE = [T["k783f859be8"], T["k9c57f67983"], T["k6b5fc1ef8a"]];
  const S_BLUE_META = [T["k3ce8cbd763"], T["k6daf54655e"], T["k3fa36dd366"]];
  const S_GREEN = [T["k8a09ef2837"], T["kc707a14b41"], T["k4b66bfd641"]];
  // Marci 10-27: a vörös fényt nem csak pattanásra vizsgálták (a régi „Nagy százalékot” blokk Park-kártyája, claim-verify-olt szöveg)
  const S_PARK = [T["ka43528fc9f"], T["k6e6ff70147"], T["k80331fcd84"]];
  const MODES = [
    {k:'voros', name:T["ka78f320ac7"], c:'#FF3B22', nm:'634', img:'piros', peaks:['voros','nir'],
     match:T["k98037539ac"],
     fx:[S_RED, S_RED_META, S_PARK]},
    {k:'kek', name:T["kb15f784938"], c:'#4657FF', nm:'414', img:'kek', peaks:['kek','nir'],
     match:T["k343136a7ae"],
     fx:[S_BLUE, S_BLUE_META]},
    {k:'zold', name:T["k542519d26c"], c:'#2FE06A', nm:'515', img:'zold', peaks:['zold','nir'],
     match:T["kdc08c9b690"],
     fx:[S_GREEN]},
    {k:'sarga', name:T["kb737090b33"], c:'#FFB302', nm:'515 + 634', img:'sarga', peaks:['zold','voros','nir'],
     match:T["k60f0158016"],
     fx:[S_GREEN, S_RED]},
    {k:'lila', name:T["kdf014f5ea6"], c:'#C24BFF', nm:'414 + 634', img:'lila', peaks:['kek','voros','nir'],
     match:T["k08ab187deb"],
     fx:[[T["k443da5d366"], T["kb4c0be796c"], T["kff1fa86548"]],
         [T["k443da5d366"], T["k84194decec"], T["k9c4c2a687d"]],
         [T["k443da5d366"], T["kb4b3b9b9e2"], T["k822eba219b"]]]},
    {k:'cian', name:T["ka1e3374921"], c:'#22D3E0', nm:'414 + 515', img:'cian', peaks:['kek','zold','nir'],
     match:T["kb89cc02e36"],
     fx:[S_BLUE, S_GREEN]},
    {k:'feher', name:T["k6a5bad4ba1"], c:'#9AA3B5', nm:'414 + 515 + 634', img:'feher', peaks:['kek','zold','voros','nir'],
     match:T["k99f01b3cf5"],
     fx:[S_RED, S_BLUE, S_GREEN]}
  ];
  const fig = $('fig'), modesEl = $('modes');
  if (fig && modesEl) {
    MODES.forEach(m => {
      const im = new Image(); im.className = 'spec'; im.dataset.k = m.k; im.width = 1181; im.height = 821; im.loading = 'lazy'; im.decoding = 'async';
      im.src = IMG('lm-spektrum-' + m.k + '.webp'); im.alt = T["kbe4f6e0838"] + ': ' + m.name;
      fig.appendChild(im);
    });
    Object.entries(BANDS).forEach(([k, b]) => {
      const d = document.createElement('div'); d.className = 'band'; d.dataset.b = k;
      d.style.left = X(b.from) + '%'; d.style.width = (X(b.to) - X(b.from)) + '%'; d.style.setProperty('--bc', b.c);
      fig.appendChild(d);
      const s = document.createElement('span'); s.dataset.b = k; s.textContent = b.lab;
      s.style.left = X((b.from + b.to) / 2) + '%'; s.style.setProperty('--bc', b.c);
      $('blabs').appendChild(s);
    });
  }
  const pkWrap = document.createElement('div'); if (fig) fig.appendChild(pkWrap);
  const line = document.createElement('div'); line.className = 'scanline'; if (fig) fig.appendChild(line);
  const inset = document.createElement('div'); inset.className = 'inset';
  inset.innerHTML = MODES.map(m => `<img data-k="${m.k}" src="${IMG('lm-mode-' + m.img + '.jpg')}" alt="" loading="lazy">`).join('');
  if (fig) fig.appendChild(inset);
  MODES.forEach((m, i) => {
    if (!modesEl) return;
    const b = document.createElement('button'); b.type = 'button'; b.className = 'md'; b.style.setProperty('--c', m.c);
    b.setAttribute('aria-pressed', 'false'); b.innerHTML = '<i></i>' + m.name;
    b.addEventListener('click', () => { stopAuto(); set(i); });
    modesEl.appendChild(b);
  });
  let cur = 0;
  function set(i){
    if (!fig) return;
    cur = i; const m = MODES[i];
    root.style.setProperty('--m', m.c);
    fig.querySelectorAll('.spec').forEach(s => {
      const on = s.dataset.k === m.k; s.classList.toggle('on', on); s.classList.remove('scan');
      if (on) { void s.offsetWidth; s.classList.add('scan'); }
    });
    line.classList.remove('sw'); void line.offsetWidth; line.classList.add('sw');
    inset.querySelectorAll('img').forEach(s => s.classList.toggle('on', s.dataset.k === m.k));
    fig.querySelectorAll('.band').forEach(d => d.classList.toggle('hit', m.peaks.includes(d.dataset.b)));
    $('blabs').querySelectorAll('span').forEach(d => d.classList.toggle('hit', m.peaks.includes(d.dataset.b)));
    pkWrap.innerHTML = m.peaks.map(p => {
      const [nm, c] = PEAK[p];
      return `<div class="pk" style="left:${X(nm)}%;--pc:${c}"><b>${p === 'nir' ? 'NIR' : nm}</b></div>`;
    }).join('');
    modesEl.querySelectorAll('.md').forEach((b, j) => b.setAttribute('aria-pressed', j === i ? 'true' : 'false'));
    $('r-name').textContent = m.name;
    $('r-nm').innerHTML = /^\d+$/.test(m.nm) ? `${m.nm}<small> nm</small><span class="rsrc">${T["k12c0f03f92"]}</span>` : `<span class="rnm-c">${m.nm}<small> nm</small></span>`;
    $('r-match').innerHTML = m.match;
    $('r-fx').innerHTML = m.fx.map(([f, r, src]) => `<li><span class="sf">${f}</span><b>${r}</b><small>${src}</small></li>`).join('');
    $('r-warn').innerHTML = (m.peaks.includes('kek') ? `<li class="warn"><span class="sf">${T["kad05a1cf85"]}</span><b>${T["kfb378f568a"]}</b><small>${T["kb0dbfde117"]}</small></li>` : '');
  }
  // a „Teljes kép” csempéiről: ugrás a spektrumhoz egy adott módra, kinyitott vizsgálat-listával
  window.lm9Mode = k => { const i = MODES.findIndex(m => m.k === k); if (i < 0) return; stopAuto(); set(i); const d = root.querySelector('.fxd'); if (d) d.open = true; };
  const goR = $('r-go'); if (goR) goR.addEventListener('click', () => $('rutin').scrollIntoView({block:'start', behavior: reduce ? 'auto' : 'smooth'}));
  const DUR = 3400; let timer = null; const prog = $('prog');
  if (prog) prog.style.setProperty('--dur', DUR + 'ms');
  const runProg = () => { if (!prog) return; prog.classList.remove('run'); void prog.offsetWidth; prog.classList.add('run'); };
  function startAuto(){ if (reduce || !fig) return; runProg(); timer = setInterval(() => { set((cur + 1) % MODES.length); runProg(); }, DUR); }
  function stopAuto(){ clearInterval(timer); timer = null; if (prog) prog.classList.remove('run'); }

  /* ---------- RUTIN ---------- */
  // A sziluettek a Dermastamp-oldal rutin-blokkjából (dspv-sil).
  const SIL = {
    pump:'<path class="b" d="M10 8H194A10 10 0 0 1 204 18V62A10 10 0 0 1 194 72H10A10 10 0 0 1 0 62V18A10 10 0 0 1 10 8Z"/><rect class="c" x="207" y="20" width="16" height="40" rx="3"/><rect class="c" x="225" y="13" width="18" height="54" rx="3"/><path class="c" d="M243 16h43a5 5 0 0 1 5 5v42l-3 9-3-9V25h-42z"/>',
    drop:'<path class="b" d="M10 8H168C190 8 202 22 202 40S190 72 168 72H10A10 10 0 0 1 0 62V18A10 10 0 0 1 10 8Z"/><rect class="c" x="205" y="10" width="4" height="60" rx="1.5"/><rect class="c" x="212" y="14" width="26" height="52" rx="6"/><path class="c" d="M240 22h36a18 18 0 0 1 0 36h-36z"/>',
    jar:'<path class="b" d="M8 13H190V67H8A8 8 0 0 1 0 59V21A8 8 0 0 1 8 13Z"/><rect class="c" x="193" y="5" width="30" height="70" rx="6"/>',
    tube:'<rect class="c" x="0" y="16" width="26" height="48" rx="6"/><path class="b" d="M40 15C33 15 29 19 29 25V55C29 61 33 65 40 65L258 75V5Z"/><rect class="c" x="261" y="3" width="8" height="74" rx="1.5"/>'
  };
  // own: a saját terméked neve; base: ami a csomagban jön (null = nincs a csomagban, opcionális).
  // Egy rutin, cél szerinti mód-ajánlás NÉLKÜL (ledmask_claims 7.: a cél szerinti program indikációs tábla).
  const STEP = {
    lemoso:{sil:'pump', own:T["kc46828301d"], base:T["k9603118369"]},
    hatoa: {sil:'drop', own:T["k8c35daaa8a"], base:null, opt:T["k20fd31fcbb"]},
    krem:  {sil:'jar',  own:T["k24cae37629"], base:T["k78c56bc638"]},
    spf:   {sil:'tube', own:T["k7511e6814c"], base:T["k181f298d9a"]}
  };
  const RT = {
    pm:{h:T["k09d543841a"], s:T["k0a45798408"], steps:['lemoso','LED','hatoa','krem']},
    am:{h:T["k9fe2250439"], s:T["k0b85b1ec05"], steps:['lemoso','krem','spf']}
  };
  let base = false;
  function silStep(key, n){
    const s = STEP[key], inPack = base && s.base;
    const cls = s.opt ? ' optl' : inPack ? ' add' : '';
    const name = inPack ? s.base : s.own;
    const small = s.opt ? s.opt : inPack ? (D.bfIn ? T["k7409afee87"] + ' · ' + D.bfIn : T["k7409afee87"]) : '';
    return `<li class="st${cls}"><span class="n">${n}</span><div>
      <span class="sil sil--${s.sil}"><svg viewBox="0 0 300 80" preserveAspectRatio="xMinYMid meet" aria-hidden="true">${SIL[s.sil]}</svg>
      <b class="t">${name}${small ? `<small>${small}</small>` : ''}</b></span></div></li>`;
  }
  function ledStep(n){
    return `<li class="st led"><span class="n">${n}</span><div>
      <div class="ledr"><span class="glow"></span>
        <div class="mask"><img src="${IMG('lm9-ledmaszk.webp')}" alt="${T["k0536271530"]}" loading="lazy"></div>
        <div class="ring"><svg viewBox="0 0 100 100" aria-hidden="true"><circle class="bgc" cx="50" cy="50" r="45"/><circle class="fg" cx="50" cy="50" r="45"/></svg>
          <div class="tm"><div><b class="clock">10:00</b><small>${T["kb67519d40b"]}</small></div></div></div>
      </div>
      <span class="note">${T["k6e2a381455"]}</span></div></li>`;
  }
  function col(ph, start){
    let n = start - 1;
    const items = ph.steps.map(k => { n++; return k === 'LED' ? ledStep(n) : silStep(k, n); }).join('');
    return `<div><div class="ph-h"><b>${ph.h}</b><span>${ph.s}</span></div><ol class="ol">${items}</ol></div>`;
  }
  function buyCard(){
    const d = base ? OPT.bundle : OPT.mask;
    return `<aside class="rbuy">
      <div class="hero"><img src="${d.img}" alt="${d.t}" loading="lazy"></div>
      <h3>${base ? (D.bfName || T["kb4bb452b78"]) : T["kc683ea764a"]}</h3>
      <p>${base ? T["k390379c48a"] : T["k3bccdc9d6a"]}</p>
      <div class="tot"><span>${T["k032fd70f50"]}</span><div>${d.old ? `<s>${d.old}</s>` : ''}<b>${d.price}</b></div></div>
      <button class="btn" type="button" data-add><i></i><span>${T["k1c4ed57aec"]}</span></button>
    </aside>`;
  }
  function render(){ const rt = $('rt'); if (rt) rt.innerHTML = col(RT.pm, 1) + col(RT.am, RT.pm.steps.length + 1) + buyCard(); }
  window.lm9SetBase = function(v, fromOpt){
    if (v && !hasBundle) v = false;
    base = v; const a = $('o-own'), b = $('o-base');
    if (a) a.setAttribute('aria-pressed', !v); if (b) b.setAttribute('aria-pressed', v);
    render(); if (!fromOpt) setOpt(v ? 'bundle' : 'mask');
  };
  if ($('o-own')) $('o-own').addEventListener('click', () => window.lm9SetBase(false));
  if ($('o-base')) $('o-base').addEventListener('click', () => window.lm9SetBase(true));

  // a visszaszámláló: 10 perc 12 másodpercbe sűrítve
  const LOOP = 12000;
  function tick(t){
    const f = (t % LOOP) / LOOP, left = Math.round(600 * (1 - f));
    const k = Math.floor(t / LOOP) % MODES.length;
    const rt = $('rt');
    if (rt && k !== tick.k) { tick.k = k; rt.style.setProperty('--lc', MODES[k].c); }
    const txt = Math.floor(left / 60) + ':' + String(left % 60).padStart(2, '0');
    root.querySelectorAll('.clock').forEach(c => c.textContent = txt);
    root.querySelectorAll('.ring .fg').forEach(c => c.style.strokeDashoffset = 283 * f);
    if (!reduce) requestAnimationFrame(tick);
  }

  /* ---------- SZILIKON-PAKLI + FUTÓ PONTSZÁM ---------- */
  const stack = $('stack');
  if (stack) {
    const cards = [...stack.querySelectorAll('.card2')], dots = $('dk-dots');
    let di = 0, lastA = -1, lastB = -1, started = false;
    new IntersectionObserver((es, ob) => {
      if (!es[0].isIntersecting) return;
      ob.disconnect(); setTimeout(() => { started = true; layout(); }, 350);
    }, {threshold: .5}).observe(stack);
    cards.forEach((c, i) => {
      const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', (i + 1) + ' / ' + cards.length);
      const v = c.dataset.pt; if (v === '1') b.className = 'p1'; if (v === '-1') b.className = 'm1';
      b.addEventListener('click', () => go(i)); dots.appendChild(b);
    });
    const bump = (el, side) => { el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop'); side.classList.add('hit'); setTimeout(() => side.classList.remove('hit'), 380); };
    function layout(){
      cards.forEach((c, i) => {
        const d = i - di;
        c.style.zIndex = 100 - Math.abs(d);
        if (d < 0) { c.dataset.d = 'gone'; c.style.transform = 'translateX(-112%) rotate(-9deg)'; c.style.filter = ''; }
        else if (d === 0) { c.dataset.d = '0'; c.style.transform = 'none'; c.style.filter = 'none'; c.style.opacity = 1; }
        else {
          const k = Math.min(d, 3);
          c.dataset.d = String(d); c.style.transform = `translateY(${k * 16}px) scale(${1 - k * .045})`;
          c.style.filter = `brightness(${1 - k * .18})`; c.style.opacity = d > 3 ? 0 : 1;
        }
        c.setAttribute('aria-hidden', d !== 0);
        const v = c.querySelector('video'); if (v) { if (d === 0 && !reduce) v.play().catch(() => {}); else v.pause(); }
      });
      const seen = started ? cards.slice(0, di + 1) : [];
      const a = seen.filter(c => c.dataset.pt === '-1').length, b = seen.filter(c => c.dataset.pt === '1').length;
      if (a !== lastA) { $('sc-a').textContent = a; if (lastA >= 0) bump($('sc-a'), $('ds-a')); lastA = a; }
      if (b !== lastB) { $('sc-b').textContent = b; if (lastB >= 0) bump($('sc-b'), $('ds-b')); lastB = b; }
      $('sc-step').textContent = (di + 1) + ' / ' + cards.length;
      [...dots.children].forEach((d, j) => d.setAttribute('aria-current', j === di));
      $('dk-n').textContent = (di + 1) + ' / ' + cards.length;
      $('dk-prev').disabled = di === 0; $('dk-next').disabled = di === cards.length - 1;
    }
    const go = i => { di = Math.max(0, Math.min(cards.length - 1, i)); layout(); };
    $('dk-prev').addEventListener('click', () => go(di - 1));
    $('dk-next').addEventListener('click', () => go(di + 1));
    stack.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(di + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(di - 1); }
    });
    // húzás: a felső kártyát balra dobod a következőért, jobbra húzva visszajön az előző
    let sx = null, dx = 0, top = null;
    stack.addEventListener('pointerdown', e => {
      if (e.target.closest('summary, a, button, .in')) return;
      top = cards[di]; sx = e.clientX; dx = 0; top.classList.add('dragging'); stack.setPointerCapture(e.pointerId);
    });
    stack.addEventListener('pointermove', e => { if (sx === null) return; dx = e.clientX - sx; top.style.transform = `translateX(${dx}px) rotate(${dx / 40}deg)`; });
    const end = () => {
      if (sx === null) return; top.classList.remove('dragging'); sx = null;
      if (dx < -80 && di < cards.length - 1) go(di + 1); else if (dx > 80 && di > 0) go(di - 1); else layout();
    };
    stack.addEventListener('pointerup', end); stack.addEventListener('pointercancel', end);
    layout();
  }

  /* ---------- MONOGRAM ---------- */
  const mono = $('mono'); if (mono) mono.addEventListener('input', e => { $('mono-tag').textContent = e.target.value.toUpperCase() || 'MK'; });

  /* ---------- GYIK ---------- */
  const FAQ = [
    {g:T["k5245fb1669"], items:[
      [T["k625a114651"], T["k87393dc370"]],
      [T["ka999e95b5f"], T["kd206927447"]],
      [T["k6e7283eef1"], T["k532053cd6e"]],
      [T["k79abb69213"], T["k0c6c2d5471"]]
    ]},
    {g:T["k2645f4ccc0"], items:[
      [T["kcf11391255"], T["k8a5c6d4e1e"]],
      [T["k927dca3a92"], T["k0c4651cc2d"]],
      [T["k4eaa9d89b7"], T["kd4476e780d"]],
      [T["k799efebf5c"], T["k274357214b"]],
      [T["ke47f4de8f0"], T["k970019db03"]]
    ]},
    {g:T["kd2d551e2fc"], items:[
      [T["kf80a5d7de2"], T["k10e8ea776e"]],
      [T["k8cbaac3ba1"], T["k90b48c47eb"]],
      [T["k4340cdf262"], T["k6394d22950"]],
      [T["k5e47fa7277"], T["k94346cb3c5"]]
    ]},
    {g:T["k13109dbbf3"], items:[
      [T["k949fb33bc6"], T["k16e4d2fad9"]],
      [T["kb259ce2885"], T["kf3dcfd07fe"]],
      [T["k789f4734e2"], T["k9e537f1f5b"]],
      [T["kf03ceeb0b2"], T["k02986cbcef"]]
    ]}
  ];
  const nav = $('faq-nav'), qa = $('qa'); let fg = 0;
  function renderFaq(){
    nav.querySelectorAll('button').forEach((b, j) => b.setAttribute('aria-pressed', j === fg));
    qa.innerHTML = FAQ[fg].items.map(([q, a], j) => `<details class="acc"${j === 0 ? ' open' : ''}><summary>${q}</summary><div class="in"><p>${a}</p></div></details>`).join('');
  }
  if (nav && qa) {
    FAQ.forEach((f, i) => {
      const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-pressed', i === 0);
      b.innerHTML = `${f.g}<span>${f.items.length}</span>`;
      b.addEventListener('click', () => { fg = i; renderFaq(); });
      nav.insertBefore(b, nav.querySelector('.ask'));
    });
  }

  /* ---------- RAGADÓS SÁV: a body közvetlen gyereke (a footer a main fölé fest) ---------- */
  const sticky = document.querySelector('.lm9-stk');
  const anchorBtn = buy && buy.querySelector('.lm2-btn');
  if (sticky && anchorBtn) {
    document.body.appendChild(sticky);
    new IntersectionObserver(([e]) => {
      const show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('on', show); sticky.setAttribute('aria-hidden', !show);
      sticky.querySelector('button').tabIndex = show ? 0 : -1;
    }).observe(anchorBtn);
  } else if (sticky) sticky.remove();

  const bb = $('basics-btn');
  if (bb) bb.addEventListener('click', () => { setOpt('bundle'); if (buy) buy.scrollIntoView({block:'start', behavior: reduce ? 'auto' : 'smooth'}); });
  const cur0 = buy && buy.querySelector('.lm2-pick__c input:checked');
  set(0); startAuto(); render(); if (nav && qa) renderFaq();
  setOpt(cur0 && cur0.closest('.lm2-pick__c').dataset.handle === D.hb ? 'bundle' : 'mask', true);
  requestAnimationFrame(tick);
})();
